(function () {
    // 通用统计组件
    // 注册组件
    SR.modules.extend('triggerAnalytics', triggerAnalytics);
    
    function triggerAnalytics() {
        // 需要与 js/analytics.js 同步
        var alias = SR.data.alias;
        var appid = location.search.replace('?', '');

        this.uploadData = function(analyticsData) {
            var iAnalyticsData = analyticsData || {};
            var base = {
                jsid: SR.data.jsid,
                guid: SR.data.deviceInfo.guid
            }
            iAnalyticsData = Object.assign(iAnalyticsData, base);
            var query = SR.util.jsonToQuery(iAnalyticsData, alias);
            var timestamp = new Date() - 0;
            var img = new Image();
            img.src = location.protocol + '//' + location.host + '/dist/images/__sr.gif?' + appid + '&' + query + '&tp=' + timestamp;
            SR.state.isDebug && console.log(query);
        }
    }
}());